module.exports = __webpack_public_path__ + "img/frame_background.226ccdaf.png";